"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidBotIdUserError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const errorCode = "InvalidBotId";
const messageKey = "driver.botFramework.error.InvalidBotId";
class InvalidBotIdUserError extends teamsfx_api_1.UserError {
    constructor(actionName, botId, helpLink) {
        super({
            source: actionName,
            name: errorCode,
            message: (0, localizeUtils_1.getDefaultString)(messageKey, botId),
            displayMessage: (0, localizeUtils_1.getLocalizedString)(messageKey, botId),
            helpLink: helpLink,
        });
    }
}
exports.InvalidBotIdUserError = InvalidBotIdUserError;
//# sourceMappingURL=invalidBotIdError.js.map